import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const TestFailed = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M8.586 10 10 8.586l2 2 2-2L15.414 10l-2 2 2 2L14 15.414l-2-2-2 2L8.586 14l2-2-2-2Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="m21.062 9.735-6.797-6.797a3.204 3.204 0 0 0-4.53 0L2.938 9.735a3.204 3.204 0 0 0 0 4.53l6.797 6.797a3.204 3.204 0 0 0 4.53 0l6.797-6.797a3.204 3.204 0 0 0 0-4.53Zm-9.913-5.382c.47-.47 1.232-.47 1.702 0l6.796 6.796c.47.47.47 1.232 0 1.702l-6.796 6.796c-.47.47-1.232.47-1.702 0l-6.796-6.796a1.204 1.204 0 0 1 0-1.702l6.796-6.796Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default TestFailed;
